// BUG-134: 미로그인 hard-load 시 이동할 로그인 경로 결정.
// admin 컨텍스트(/admin/*, /pmcf)는 /Admin/Login, 그 외 /Login.
// 이미 로그인 경로면 null 반환 → 호출측이 push 생략(루프 방지).
import { ROUTES } from '../config/routes';

// IMP-138: lowercase-normalized 비교용 (비교 전 pathname 도 toLowerCase). ROUTES 정본 파생.
const LOGIN_PATHS = [ROUTES.LOGIN, ROUTES.ADMIN_LOGIN].map((p) => p.toLowerCase());

// BUG-166: 미인증 사용자가 정상 접근하는 공개 경로 — 로그인으로 리다이렉트 금지.
// app.js 의 비-AuthRoute 공개 <Route> 전수와 동기화해야 한다(추가/변경 시 함께 갱신):
//   메인 Switch: /ForgotPassword, /ResetNewPassword, /ForgotPasswordSent, /IubendaLogin, /Terms
//   standAlone Switch: /register (제품 자가등록, 미인증 고객 대면)
// 미포함 시 (1) mount 가드(app.js) 와 (2) 401 인터셉터(axiosSetup.js) 양쪽이 로그인으로 튕겨,
// 비밀번호 재설정/찾기·약관·제품등록 진입이 불가해진다(standAlone /register 는 빈 화면).
const PUBLIC_PATHS = [
    '/forgotpassword',
    '/resetnewpassword',
    '/forgotpasswordsent',
    '/iubendalogin',
    '/terms',
    '/register',
];

// 관리자 컨텍스트 판정 SSoT: '/admin/' 접두(대소문자 무시) 또는 정확히 '/pmcf'.
// app.js computeLayoutFlags / AuthRoute / NotFound 가 이 함수를 공유한다.
export const isAdminContextPath = (pathname) => {
    const p = (pathname || '').toLowerCase();
    return p.startsWith('/admin/') || p === '/pmcf';
};

export const resolveUnauthRedirect = (pathname) => {
    const p = (pathname || '').toLowerCase();
    if (LOGIN_PATHS.includes(p)) return null;
    if (PUBLIC_PATHS.includes(p)) return null;
    return isAdminContextPath(p) ? ROUTES.ADMIN_LOGIN : ROUTES.LOGIN;
};
